export const GET_USER_REQUEST = "@authorization/GET_USER_REQUEST";
export const GET_USER_SUCCESS = "@authorization/GET_USER_SUCCESS";
export const GET_USER_FAILURE = "@authorization/GET_USER_FAILURE";

export const SET_ERROR = "@authorization/SET_ERROR";
export const SET_MESSAGE = "@authorization/SET_MESSAGE";